import './chunk-455cdeae.js';
import './helpers.js';
import './chunk-e92e3389.js';
import './chunk-17b33cd2.js';
import './chunk-7e17a637.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { I as Input } from './chunk-83c8b459.js';
export { I as BInput } from './chunk-83c8b459.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Input);
  }
};
use(Plugin);

export default Plugin;
